import './Storefront.css';

function Section({ section }) {
  if (section.type === 'hero') return null;
  if (section.type === 'audience') {
    return (
      <section className="sf-section sf-section-split">
        <div>
          {section.eyebrow && <p className="sf-eyebrow">{section.eyebrow}</p>}
          <h2>{section.title || 'For readers who want more'}</h2>
        </div>
        <ul className="sf-bullet-list">
          {(section.bullets || []).map((bullet, index) => <li key={`${section.id}-${index}`}>{bullet}</li>)}
        </ul>
      </section>
    );
  }
  if (section.type === 'faq') {
    return (
      <section className="sf-section">
        {section.eyebrow && <p className="sf-eyebrow">{section.eyebrow}</p>}
        <h2>{section.title || 'Questions'}</h2>
        <div className="sf-faq-list">
          {(section.items || []).map((item, index) => (
            <div className="sf-faq-item" key={`${section.id}-${index}`}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
      </section>
    );
  }
  if (section.type === 'cta') {
    return (
      <section className="sf-cta-band">
        <h2>{section.title || 'Follow the launch'}</h2>
        {section.body && <p>{section.body}</p>}
      </section>
    );
  }
  return (
    <section className={`sf-section sf-${section.type}`}>
      {section.eyebrow && <p className="sf-eyebrow">{section.eyebrow}</p>}
      <h2>{section.title || (section.type === 'authorNote' ? 'Author note' : 'About the book')}</h2>
      {section.body && <p>{section.body}</p>}
    </section>
  );
}

export default function StorefrontPreview({ payload, statusLabel = '', publicMode = false }) {
  const sections = payload?.sections || [];
  const hero = sections.find((section) => section.type === 'hero') || sections[0] || {};
  const theme = payload?.theme || 'editorial';
  const ctaDisabled = payload?.ctaMode !== 'external' || !payload?.ctaUrl;
  const heroImageUrl = payload?.bookMockupImageUrl || payload?.coverImageUrl;
  const heroImageClass = payload?.bookMockupImageUrl ? 'sf-book-mockup' : 'sf-cover';

  return (
    <article className={`sf-page sf-theme-${theme} ${publicMode ? 'public' : 'preview'}`}>
      <header className="sf-hero">
        <div className="sf-hero-copy">
          <p className="sf-kicker">{hero.eyebrow || payload?.tagline || 'Book launch'}</p>
          <h1>{hero.title || payload?.title || 'Untitled Book'}</h1>
          {(hero.body || payload?.subtitle) && <p className="sf-hero-subtitle">{hero.body || payload.subtitle}</p>}
          <div className="sf-hero-actions">
            {ctaDisabled ? (
              <button className="sf-cta" disabled>{payload?.ctaLabel || 'Preorder coming soon'}</button>
            ) : (
              <a className="sf-cta" href={payload.ctaUrl} target="_blank" rel="noreferrer">{payload.ctaLabel || 'Buy now'}</a>
            )}
            {statusLabel && <span className="sf-status-label">{statusLabel}</span>}
          </div>
        </div>
        <div className="sf-cover-wrap">
          {heroImageUrl ? (
            <img className={heroImageClass} src={heroImageUrl} alt={`${payload.title || 'Book'} book mockup`} />
          ) : (
            <div className="sf-cover sf-cover-placeholder">
              <span>{payload?.title || 'Book Cover'}</span>
            </div>
          )}
        </div>
      </header>

      <main className="sf-main">
        {(payload?.coverImageUrl || payload?.backCoverImageUrl) && (
          <section className="sf-section sf-cover-gallery">
            <div>
              <p className="sf-eyebrow">Book design</p>
              <h2>Front and back cover</h2>
            </div>
            <div className="sf-cover-gallery-images">
              {payload.coverImageUrl && <img src={payload.coverImageUrl} alt={`${payload.title || 'Book'} front cover`} />}
              {payload.backCoverImageUrl && <img src={payload.backCoverImageUrl} alt={`${payload.title || 'Book'} back cover`} />}
            </div>
          </section>
        )}
        {sections.filter((section) => section.type !== 'hero').map((section) => (
          <Section key={section.id} section={section} />
        ))}
      </main>
    </article>
  );
}
